var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "class-page",
      staticStyle: { padding: "15px" },
      attrs: { id: "classPage" }
    },
    [
      _c("class-page-header", {
        attrs: {
          details: _vm.details,
          "current-section": parseInt(_vm.sectionId),
          course: _vm.course,
          menu: _vm.menu,
          "is-class-item-page": true
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "back-link" }, [
        _c(
          "a",
          {
            staticStyle: { cursor: "pointer" },
            on: {
              click: function($event) {
                return _vm.$router.go(-1)
              }
            }
          },
          [
            _c("i", {
              staticClass: "fas fa-caret-left",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(
              _vm._s(_vm.$t("MAIN_CONTENT.commonContent.goBack")) + "\n\t\t\t"
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "class-page-body" }, [
        _c("h2", [_vm._v(_vm._s(_vm.subpage.REPORT_NAME))]),
        _vm._v(" "),
        _c("div", {
          domProps: { innerHTML: _vm._s(_vm.subpage.REPORT_DESCRIPTION) }
        })
      ]),
      _vm._v(" "),
      _c("class-page-footer", {
        attrs: {
          course: _vm.course,
          menu: _vm.menu,
          "current-section": parseInt(_vm.sectionId),
          "is-class-item-page": true
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "back-link" }, [
        _c(
          "a",
          {
            staticStyle: { cursor: "pointer" },
            on: {
              click: function($event) {
                return _vm.$router.go(-1)
              }
            }
          },
          [
            _c("i", {
              staticClass: "fas fa-caret-left",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(
              _vm._s(_vm.$t("MAIN_CONTENT.commonContent.goBack")) + "\n\t\t\t"
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }